import React from "react";
import { PORT_VIEW, PortHookInterface } from "../portDetailsHook";
import WaveXchangeLogo from "../../../assets/images/wavexchange-logo-color.svg";
import WaveXchangeLogoSmall from "../../../assets/images/wavexchange-small-icon.svg";
import { areYouSure, wrapInTooltip } from "../../../utils/methods";
import Button from "../../DesignSystem/button";
import EditIcon from "../../../assets/images/edit-icon.svg";
import useMoveToWaveXchange from "../moveToWaveXchangeHook";
import { ManageLeasedPortsType } from "../useManageLeasedPorts";
interface WaveXchangeButtonInterface {
  portProps: {
    portDetails: PORT_VIEW | null;
    moveToWaveXchange: ReturnType<typeof useMoveToWaveXchange>;
    manageLeasedPorts: ManageLeasedPortsType;
  };
}

const WaveXchangeButton: React.FC<WaveXchangeButtonInterface> = ({ portProps }) => {
  const { portDetails: port, moveToWaveXchange, manageLeasedPorts } = portProps;

  const organizationId = Number(localStorage.getItem("org_id") || -1);

  const getButton = () => {
    if (!port) return <div />;

    if (port.buyer_id) return <div>Sold to {port.buyer_organization}</div>;

    if (port.ne_on_net) {
      if (!(port.ne_leased_organization && port.ne_leased_organization === organizationId)) {
        if (port.verified) return wrapInTooltip(<img src={WaveXchangeLogo} alt="WaveXchange logo" />, "Port is on WaveXchange");

        if (!port.parent_id) {
          if (port.requested_verification) {
            return (
              <div className="move-to-wx-button">
                <Button
                  variant="green"
                  node={
                    <div className="flex">
                      <img src={WaveXchangeLogoSmall} alt="wavexchange pending" />
                      Pending...
                    </div>
                  }
                  disabled
                />
              </div>
            );
          }
          if (!port.listing_id) {
            return (
              <div className="move-to-wx-button">
                <Button
                  // WV-2453 Action Costs Money
                  onClick={() => areYouSure(() => moveToWaveXchange.moveToWaveXchange(), `Move ${port.port_description} ${port.port_name} to WaveXchange?`)}
                  variant="green"
                  loading={moveToWaveXchange.loading}
                  node={
                    <div className="flex">
                      Move to
                      <img src={WaveXchangeLogoSmall} alt="move to wavexchange" />
                    </div>
                  }
                />
              </div>
            );
          }
        }
      } else {
        if (port.verified) {
          return (
            <>
              <img src={WaveXchangeLogo} alt="WaveXchange logo" />
              <img src={EditIcon} alt="edit" className="pointer" onClick={() => manageLeasedPorts.openDrawer()}/>
            </>
          );
        } else {
          return (
            <div className="move-to-wx-button">
              <Button
                onClick={() => {
                  manageLeasedPorts.openDrawer();
                }}
                variant="green"
                node={
                  <div className="flex">
                    Connect to
                    <img src={WaveXchangeLogoSmall} alt="connect to wavexchange" />
                  </div>
                }
              />
            </div>
          );
        }
      }
    } else {
      return <div>No switch present at Node</div>;
    }
    return <div />;
  };
  return (
    <>
      {getButton()}
      {manageLeasedPorts.drawerComponent}
    </>
  );
};

export default WaveXchangeButton;
